import React from "react";
import '../Dashboard.scss'
import DefaultCard from "../../../components/atoms/DefaultCard/DefaultCard";
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import InputLista from "../../../components/atoms/InputLista/InputLista";

import { Button } from "primereact/button";


const Filtros = ({ 
    setFechaInicio,
    fechaInicio,
    setFechaFin,
    fechaFin,
    setBuscar,
    buscar ,
}) => {
   
    return (
        <>
            <DefaultCard>
                <div className="containerButtonAyuda">
                    <div className="titulo">Filtro de busqueda</div>
                    {/* <BotonAyuda template={ayudaTemplate} ></BotonAyuda> */}
                </div>
                <hr />
                <div className="contenido-menu-filtros-dashboard">
                    <div className="izquierda">
                        <div className="contenedorInputsFecha">
                            <InputCalendario onChange={(e) => { setFechaInicio(e.value) }} value={fechaInicio} obligatorio={false} titulo={"Desde:"}></InputCalendario>
                            <InputCalendario onChange={(e) => { setFechaFin(e.value) }} value={fechaFin} obligatorio={false} titulo={"Hasta:"}></InputCalendario>
                            {/* {
                                dataUser?.EMPRESA_ASIGNADA == 5 ?
                                    <InputLista value={idCliente} onChange={(e) => { setIdCliente(e.value) }} titulo={"Filtro por cliente"} placeholder={"Selecciona el cliente"} options={idClientes} optionLabel={"name"}></InputLista>
                                    : ""
                            } */}
                        </div>
                    </div>
                    <div className="derecha">
                        <div className="contenedorBotonBuscar">
                           <Button
                                label={'Buscar'}
                                icon="pi pi-search"
                                className="button-buscar"
                                onClick={() => { setBuscar(!buscar) }}
                                style={{background:'#343A40'}}
                            />
                           
                        </div>
                    </div>
                </div>
            </DefaultCard>
        </>
    )
}
export default Filtros